import { MapPin, Star, UtensilsCrossed, Flower2 } from "lucide-react";

const features = [
  {
    icon: MapPin,
    title: "Prime Location",
    desc: "Situated 200km North of Johannesburg and 36km east of Modimolle, in the bushveld region of the Limpopo Province, a malaria free area.",
  },
  {
    icon: Star,
    title: "Celebrate Life’s Most Meaningful Moments",
    desc: "Let us help you turn a special moment into an unforgettable experience. Romantic escapes, Birthdays, honeymoons, anniversaries, proposals",
  },
  {
    icon: UtensilsCrossed,
    title: "Culinary Safari",
    desc: "Traditional boma evenings\nBespoke private dining setups for couples\nPrivate bushveld picnics\nMeals to slow down time",
  },
  {
    icon: Flower2,
    title: "Wellness & Relaxation",
    desc: "Enhance your stay with restorative experiences:\nCouples spa treatments\nIn-room massages\nQuiet poolside afternoons\nHere, relaxation is effortless.",
  },
];

const FeaturesBar = () => {
  return (
    <section className="bg-secondary py-0 border-y border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {features.map((f) => (
            <div key={f.title} className="text-center">
              <f.icon className="mx-auto mb-3 text-gold" size={28} strokeWidth={1.5} />
              <h3 className="font-heading text-sm tracking-wider text-foreground mb-2">
                {f.title}
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed whitespace-pre-line">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesBar;
